import { View } from '@gogame/components';

import { PortalProvider } from '../Portal';

const ScreenProvider = ({ children, loading }) => {
  return (
    <View loading={loading}>
      <PortalProvider>{children}</PortalProvider>
    </View>
  );
};

export default ScreenProvider;
